import React from 'react'
import sampleImg from "./Project_Images/sampleImg.png"

const ProjectCard = (props) => {
    return (
        <div class="card" style={{ background: props.color }}>
            <div class="card_text">
                <h2>{props.title}</h2>
                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Saepe rerum molestias harum ut pariatur
                    voluptas maiores officia magni fuga, consequatur temporibus fugit dolorem ipsa, doloribus illum,
                    beatae consequuntur expedita dolorum.</p>
            </div>

            <div class="card_img">
                <img src={sampleImg} alt="Sample sites"/>
            </div>

            <div class="card_link">
                <a href="#">Visit Site</a>
            </div>
        </div>
    )
}

export default ProjectCard
